'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

exports.default = (0, _common.withParams)({ type: 'required' }, _common.req);


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/required.js
// module id = 2280
// module chunks = 0